import React, { PropsWithChildren, ReactNode, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import useRelativeCoordsAndSize, { RelativePosition } from '../../hooks/useRelativeCoordsAndSize';

interface Props {
    position?: RelativePosition;
    content?: ReactNode;
}

const Tooltip = ({ children, position = 'top', content = null }: PropsWithChildren<Props>) => {
    const rootRef = useRef<HTMLDivElement | null>(null);

    const { coords } = useRelativeCoordsAndSize(
        rootRef,
        position,
        document.getElementById('admin-content'),
    );

    const [active, setActive] = useState(false);

    const nodes = (
        <div
            className={`tooltip ${position}`}
            style={{
                left: coords.x,
                top: coords.y,
            }}
        >
            {content}
        </div>
    );

    const root = document.getElementById('root');
    if (!root) return null;

    return (
        <div
            ref={rootRef}
            className="tooltip-wrapper"
            onMouseOver={() => setActive(true)}
            onMouseLeave={() => setActive(false)}
        >
            {children}
            {active && createPortal(nodes, root)}
        </div>
    );
};

export default Tooltip;
